import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import moment from 'moment'
import { useTranslation } from 'react-i18next';

// Components
import TournamentFAQ from 'components/tournament_details/TournamentFAQ';
import TournamentTimeline from 'components/tournament_details/TournamentTimeline';
import TournamentRegistrationForm from 'components/tournament_details/TournamentRegistrationForm';
import TournamentTerms from 'components/tournament_details/TournamentTerms';

// Apis
import useFetch from 'utils/hooks/useFetch'
import { GET_TOURNAMENT, GET_TOURNAMENT_SCHEDULE, GET_TOURNAMENT_FAQS } from 'api';
const { TOURNAMENT_ID } = require('../config.js');

function TournamentDetails() {
  const { data: tournament, fetch: getTournament } = useFetch(GET_TOURNAMENT)
  const { data: schedules, fetch: getTournamentSchedules } = useFetch(GET_TOURNAMENT_SCHEDULE)
  const { data: tournamentFaqs, fetch: getTournamentFaqs } = useFetch(GET_TOURNAMENT_FAQS)

  const { t } = useTranslation();
  const id = TOURNAMENT_ID;

  const [isRegistrationFormOpen, setIsRegistrationFormOpen] = useState(false);

  useEffect(() => {
    getTournament({
      params: {
        id
      }
    })
  }, [
    getTournament,
    id
  ])

  useEffect(() => {
    if (tournament && tournament.id) {
      getTournamentSchedules({
        params: {
          tournament_id: tournament.id
        },
        data: {
          sort: ['id', 'ASC'],
        }
      })
    }
  }, [
    tournament,
    getTournamentSchedules
  ])

  useEffect(() => {
    if (tournament && tournament.id) {
      getTournamentFaqs({
        params: {
          tournament_id: tournament.id
        }
      })
    }
  }, [
    tournament,
    getTournamentFaqs
  ])

  const handleButtonRegister = (link) => {
    if (link && link !== '') {
      window.open(link, '_blank')
    } else {
      setIsRegistrationFormOpen(!isRegistrationFormOpen)
    }
  }

  return (
    <>
      <div className='fixed w-full h-full'>
        <img className='object-cover object-center h-full w-full' src={tournament && tournament.bg_image_url} />
      </div>
      <div className='relative pb-8'>

        <section>
          <div>
            <img src={tournament && tournament.header_image_url} alt="main" className='w-full object-contain object-center' />
          </div>
        </section>

        {
          tournament && tournament.hero_left_image_url && (
            <img className='top-24 left-0 opacity-20 fixed w-48 sm:w-96' src={tournament && tournament.hero_left_image_url} />
          )
        }
        {
          tournament && tournament.hero_right_image_url && (
            <img className='bottom-0 right-0 opacity-20 fixed w-48 sm:w-96' src={tournament && tournament.hero_right_image_url} />
          )
        }
        {
          tournament && tournament.divider_img_url && (
            <div>
              <img alt="divider" className='w-full md:w-4/5 my-8 mx-auto object-contain object-center' src={tournament && tournament.divider_img_url} />
            </div>
          )
        }

        <section className='app-animation-translate-start'>
          <div className='max-w-7xl mx-auto px-4 py-6 md:px-12 md:py-8 space-y-8'>
            <p className={`text-center uppercase text-2xl sm:text-5xl font-bold text-${tournament && tournament.font_color ? tournament.font_color : "black"}`}>
              {tournament && tournament.title}
            </p>
            <p className={`text-center uppercase text-xl sm:text-3xl font-bold text-${tournament && tournament.font_color ? tournament.font_color : "black"}`}>
              MOBILE LEGENDS : BANG-BANG! TOURNAMENT
            </p>
            <p className={`text-center uppercase text-xl sm:text-3xl font-bold text-${tournament && tournament.font_color ? tournament.font_color : "black"}`}>
              ONLINE QUALIFIER & OFFLINE PLAYOFF (PONTIANAK & D.I YOGYAKARTA)
            </p>
          </div>
        </section>

        {
          tournament && tournament.divider_img_url && (
            <div>
              <img alt="divider" className='w-full md:w-4/5 my-8 mx-auto object-contain object-center' src={tournament && tournament.divider_img_url} />
            </div>
          )
        }

        {/* <section className='app-animation-translate-start'>
          <div className='max-w-7xl mx-auto px-4 py-6 md:px-12 md:py-8 space-y-8'>
            <p className={`text-center text-xl sm:text-3xl font-bold text-${tournament && tournament.font_color ? tournament.font_color : "black"}`}>
              Schedules
            </p>
            <p className={`text-center text-base sm:text-xl font-bold text-${tournament && tournament.font_color ? tournament.font_color : "black"}`}>
              OPEN REGISTRATION : 19 November - 2 Desember 2024
            </p>
            <p className={`text-center text-base sm:text-xl font-bold text-${tournament && tournament.font_color ? tournament.font_color : "black"}`}>
              FILTERING DATA & BLAST : 3 - 4 Desember 2024
            </p>
            <p className={`text-center text-base sm:text-xl font-bold text-${tournament && tournament.font_color ? tournament.font_color : "black"}`}>
              TECHNICAL MEETING : 5 Desember 2024
            </p>
            <p className={`text-center text-base sm:text-xl font-bold text-${tournament && tournament.font_color ? tournament.font_color : "black"}`}>
              TOURNAMENT START : 6 - 8 Desember 2024
            </p>
            <p className={`text-center text-base sm:text-xl font-bold text-${tournament && tournament.font_color ? tournament.font_color : "black"}`}>
              PLAYOFF REGION : 14 & 15 Desember 2024
            </p>
          </div>
        </section> */}

        {/* {
          tournament && tournament.divider_img_url && (
            <div>
              <img alt="divider" className='w-full md:w-4/5 my-8 mx-auto object-contain object-center' src={tournament && tournament.divider_img_url} />
            </div>
          )
        } */}

        {/* <section className='app-animation-scale-start'>
          <div className='max-w-7xl mx-auto px-4 py-6 md:px-12 md:py-8 space-y-8'>
            <p className={`text-center uppercase text-2xl sm:text-5xl font-bold text-${tournament && tournament.font_color ? tournament.font_color : "black"}`}>
              TOTAL PRIZEPOOL IDR 10.000.000 <br /> IDR 5.000.000 / Region
            </p>
            <p className={`text-center uppercase text-xl sm:text-3xl font-bold text-${tournament && tournament.font_color ? tournament.font_color : "black"}`}>
              1ST : IDR 3.000.000
            </p>
            <p className={`text-center uppercase text-xl sm:text-3xl font-bold text-${tournament && tournament.font_color ? tournament.font_color : "black"}`}>
              2ND : IDR 1.000.000
            </p>
            <p className={`text-center uppercase text-xl sm:text-3xl font-bold text-${tournament && tournament.font_color ? tournament.font_color : "black"}`}>
              3RD : IDR 500.000
            </p>
            <p className={`text-center uppercase text-xl sm:text-3xl font-bold text-${tournament && tournament.font_color ? tournament.font_color : "black"}`}>
              4TH : IDR 500.000
            </p>
          </div>
        </section> */}

        {/* {
          tournament && tournament.divider_img_url && (
            <div>
              <img alt="divider" className='w-full md:w-4/5 my-8 mx-auto object-contain object-center' src={tournament && tournament.divider_img_url} />
            </div>
          )
        } */}

        {/* <section className='app-animation-translate-start'>
          {
            tournament && tournament.terms && tournament.terms.length > 0 && (
              <TournamentTerms
                terms={tournament && tournament.terms}
                bulletIcon={tournament && tournament.bullet_icon_url}
                fontColor={tournament && tournament.font_color}
              />
            )
          }
        </section> */}

        {/* {
          tournament && tournament.divider_img_url && (
            <div>
              <img alt="divider" className='w-full md:w-4/5 my-8 mx-auto object-contain object-center' src={tournament && tournament.divider_img_url} />
            </div>
          )
        } */}

        {/* <section className='app-animation-translate-start space-y-4'>
          <div class="max-w-6xl mx-auto bg-blue-100 border-t-8 border-blue-500 rounded text-blue-900 px-4 py-3 shadow-md" role="alert">
            <div class="flex items-center justify-center">
              <div class="py-1"><svg class="fill-current h-6 w-6 text-blue-500 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" /></svg></div>
              <div>
                <p class="font-bold text-xl">SELURUH PESERTA WAJIB MEMILIKI REKENING TABUNGAN BCA DAN MEMILIKI  MOBILE BANKING 'MYBCA'.</p>
                <p class="text-lg">WAJIB MENCANTUMKAN BUKTI SCREENSHOT DARI SETIAP PEMAIN NYA.</p>
              </div>
            </div>
          </div>
        </section> */}

        {/* <section className='app-animation-translate-start space-y-4'>
          <div className="max-w-4xl mx-auto px-4 py-4 md:px-12">
            <div className="text-center bg-blue-500 text-white text-xl font-bold rounded-t px-4 py-2">
              CONTOH BUKTI KEPEMILIKAN APP MYBCA DAN REKENING BCA.
            </div>
            <div className="border border-t-0 border-blue-400 rounded-b bg-blue-100 px-4 py-3 text-blue-700">
              <img alt="image" className='w-[300px] my-8 mx-auto object-contain object-center' src={"https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/0861e9a0f20fa7c005af6ed6afd97badd43e47ef6e3820242ebe7708405dbeb8054091af51c32cea7505ef55d57318c9d9cd2d5492f07832f28cedff7a25759a9eacd86f1676f3e85dcea932cf9d3e3c177aae3b3fe2429621e222395854526836f7cd0f1bc5b4a9c98762ecccfbed4262ac6e5f0cbdaca821fb/file-1731911961787.png"} />
            </div>
          </div>
        </section> */}

        {/* <section>
          <div className='app-main-container mx-auto space-y-8'>
            <TournamentRegistrationForm id={id} tournament={tournament} />
          </div>
        </section > */}

        <p className={`text-center uppercase text-xl sm:text-3xl font-bold text-${tournament && tournament.font_color ? tournament.font_color : "black"}`}>
          Registration Closed
        </p>

        <section className='app-animation-translate-start'>
          <div className='max-w-7xl mx-auto px-4 py-6 md:px-12 md:py-8 space-y-8'>
            {tournament && tournament.footer_html && (
              <div className={`text-center text-sm sm:text-base mx-auto text-${tournament && tournament.font_color ? tournament.font_color : "black"}`} dangerouslySetInnerHTML={{ __html: tournament && tournament.footer_html }} />
            )}
          </div>
        </section>

      </div >
    </>
  )
}

export default TournamentDetails